module.exports = __webpack_public_path__ + "static/media/slide-unselected.b0620a00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/WelcomeSlider/slide-unselected.svg
// module id = 90
// module chunks = 0